/**
 * @file useRepMobile.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-07
 * @modified 2026-09-07
 */

import { useEffect, useState } from 'react';

const read = () =>
  typeof document !== 'undefined' &&
  document.body?.getAttribute('data-rep-mobile') === 'true';

/**
 * True when this is the rep phone shell — a REP badge on a narrow viewport.
 *
 * Reads the `data-rep-mobile` attribute Dashboard maintains on <body>, exactly
 * as useReadOnly reads `data-readonly` and for the same reasons: that attribute
 * is already the single source of truth, deriving it again from `badgeOf(user)`
 * and useViewport() would be a second rule to keep in step with the first, and
 * the screens that need it are handed no user at all.
 *
 * Observed rather than read once, because Dashboard sets the attribute in an
 * effect — a component that mounted first would otherwise hold a stale false.
 */
export default function useRepMobile() {
  const [repMobile, setRepMobile] = useState(read);

  useEffect(() => {
    const sync = () => setRepMobile(read());
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { attributes: true, attributeFilter: ['data-rep-mobile'] });
    return () => observer.disconnect();
  }, []);

  return repMobile;
}
